import { render } from "./_base-icon.vue?vue&type=template&id=46346b75"
import script from "./_base-icon.vue?vue&type=script&lang=js"
export * from "./_base-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__